import { useEffect, useState } from "react";
import styles from "../../../homepage/pages/Calculators.module.css";
import { analytics, logEvent } from "../../../../firebase.js";

import { BlockMath, InlineMath } from "react-katex";

import Select from "../components/Select.js";
import InputNumber from "../components/InputNumber.js";
import Output from "../components/Output.js";

import { timberBendingCombined } from "../../utils/services/calculators.js";
import { Text, useToast } from "@chakra-ui/react";

function TimberBendingCombinedObliqueOblique({}) {
  const toast = useToast();
  // BENDING
  const [bendingCombinedObliqueInputs, setBendingCombinedObliqueInputs] =
    useState({
      forest_type: "Nativa",
      timber: "Coníferas",
      timber_class: "D20",
      timber_type: "Madeira serrada",
      load_class: "Permanente",
      moisture_class: "1 (≤ 65%)",
      lx: "",
      ke_x: 1,
      ly: "",
      ke_y: 1,
      b: "",
      h: "",
      af: "",
      stress_type: "Tração",
      nsd: "",
      msd_x: "",
      msd_y: "",
    });
  const [bendingCombinedObliqueOutputs, setBendingCombinedObliqueOutputs] =
    useState({
      fc0_d: "",
      ft0_d: "",
      l0_x: "",
      l0_y: "",
      lambd_x: "",
      lambd_y: "",
      tens_nc_d: "",
      tens_nt_d: "",
      lambd_rel_x: "",
      verification_x: "",
      lambd_rel_y: "",
      verification_y: "",
      fm_d: "",
      tens_mx_d: "",
      tens_my_d: "",
      oblique_verification_x: "",
      oblique_verification_y: "",
      limit_1: "",
      limit_2: "",
      verification: "",
      memorial: {},
    });

  function updateBendingCombinedObliqueInputs(name, value) {
    if (
      name === "forest_type" ||
      name === "timber" ||
      name === "timber_class" ||
      name === "timber_type" ||
      name === "load_class" ||
      name === "moisture_class" ||
      name === "stress_type"
    ) {
      if (value === "Nativa") {
        setBendingCombinedObliqueInputs((prevInputs) => ({
          ...prevInputs,
          ["timber_class"]: "D20",
        }));
      } else if (value === "Plantada") {
        setBendingCombinedObliqueInputs((prevInputs) => ({
          ...prevInputs,
          ["timber"]: "Coníferas",
        }));
        setBendingCombinedObliqueInputs((prevInputs) => ({
          ...prevInputs,
          ["timber_class"]: "C14",
        }));
      }
      if (value === "Coníferas") {
        setBendingCombinedObliqueInputs((prevInputs) => ({
          ...prevInputs,
          ["timber_class"]: "C14",
        }));
      } else if (value === "Folhosas") {
        setBendingCombinedObliqueInputs((prevInputs) => ({
          ...prevInputs,
          ["timber_class"]: "D18",
        }));
      }
      setBendingCombinedObliqueInputs((prevInputs) => ({
        ...prevInputs,
        [name]: value,
      }));
    } else if (value === "") {
      setBendingCombinedObliqueInputs((prevInputs) => ({
        ...prevInputs,
        [name]: value,
      }));
    } else {
      setBendingCombinedObliqueInputs((prevInputs) => ({
        ...prevInputs,
        [name]: parseFloat(value),
      }));
    }
    setBendingCombinedObliqueOutputs({
      fc0_d: "",
      ft0_d: "",
      l0_x: "",
      l0_y: "",
      lambd_x: "",
      lambd_y: "",
      tens_nc_d: "",
      tens_nt_d: "",
      lambd_rel_x: "",
      verification_x: "",
      lambd_rel_y: "",
      verification_y: "",
      fm_d: "",
      tens_mx_d: "",
      tens_my_d: "",
      oblique_verification_x: "",
      oblique_verification_y: "",
      limit_1: "",
      limit_2: "",
      verification: "",
    });
  }

  function onBendingCombinedObliqueCalculate() {
    if (
      bendingCombinedObliqueInputs["lx"] === "" ||
      bendingCombinedObliqueInputs["ly"] === "" ||
      bendingCombinedObliqueInputs["b"] === "" ||
      bendingCombinedObliqueInputs["h"] === "" ||
      bendingCombinedObliqueInputs["af"] === "" ||
      bendingCombinedObliqueInputs["nsd"] === "" ||
      bendingCombinedObliqueInputs["msd_x"] === "" ||
      bendingCombinedObliqueInputs["msd_y"] === ""
    ) {
      toast({
        title: "Preencha todos os campos",
        status: "warning",
        isClosable: true,
      });
    } else if (
      bendingCombinedObliqueInputs["lx"] === 0 ||
      bendingCombinedObliqueInputs["ly"] === 0 ||
      bendingCombinedObliqueInputs["b"] === 0 ||
      bendingCombinedObliqueInputs["h"] === 0 ||
      bendingCombinedObliqueInputs["nsd"] === 0 ||
      bendingCombinedObliqueInputs["msd_x"] === 0 ||
      bendingCombinedObliqueInputs["msd_y"] === 0
    ) {
      toast({
        title: "Os valores devem ser diferentes de 0",
        status: "warning",
        isClosable: true,
      });
    } else {
      timberBendingCombined(bendingCombinedObliqueInputs).then((response) => {
        setBendingCombinedObliqueOutputs(response["data"]);
        logEvent(analytics, "button_click", {
          button_name: "timber-bending-combined-oblique-calculator-button",
        });
      });
    }
  }

  useEffect(() => {
    logEvent(analytics, "page_view", {
      page: "timber-bending-combined-oblique-calculator",
    });
  }, []);

  return (
    <div className={styles.section} key={"header"}>
      <h1 className={styles.calculatorName}>Flexão Composta Oblíqua:</h1>
      <div className={styles.calculator}>
        <div className={styles.inputs}>
          <div className={styles.inputRow}>
            <h3 className={styles.rowTitle}>Dados de entrada:</h3>
          </div>
          <div className={styles.inputRow}>
            <Select
              text="Floresta"
              elements={["Nativa", "Plantada"]}
              unit=""
              onChange={(e) =>
                updateBendingCombinedObliqueInputs(
                  "forest_type",
                  e.target.value
                )
              }
              value={bendingCombinedObliqueInputs["forest_type"]}
            />
            {bendingCombinedObliqueInputs["forest_type"] === "Plantada" && (
              <Select
                text="Madeira"
                elements={["Coníferas", "Folhosas"]}
                unit=""
                onChange={(e) =>
                  updateBendingCombinedObliqueInputs("timber", e.target.value)
                }
                value={bendingCombinedObliqueInputs["timber"]}
              />
            )}
          </div>
          <div className={styles.inputRow}>
            <Select
              text="Classe"
              elements={
                bendingCombinedObliqueInputs["forest_type"] === "Nativa"
                  ? ["D20", "D30", "D40", "D50", "D60"]
                  : bendingCombinedObliqueInputs["forest_type"] ===
                        "Plantada" &&
                      bendingCombinedObliqueInputs["timber"] === "Coníferas"
                    ? [
                        "C14",
                        "C16",
                        "C18",
                        "C20",
                        "C22",
                        "C24",
                        "C27",
                        "C30",
                        "C35",
                        "C40",
                        "C45",
                        "C50",
                      ]
                    : bendingCombinedObliqueInputs["forest_type"] ===
                          "Plantada" &&
                        bendingCombinedObliqueInputs["timber"] === "Folhosas"
                      ? ["D18", "D24", "D30", "D35", "D40", "D50", "D60", "D70"]
                      : []
              }
              unit=""
              onChange={(e) =>
                updateBendingCombinedObliqueInputs(
                  "timber_class",
                  e.target.value
                )
              }
              value={bendingCombinedObliqueInputs["timber_class"]}
            />
            <Select
              text="Classe de umid."
              elements={["1 (≤ 65%)", "2 (≤ 75%)", "3 (≤ 85%)", "4 (> 85%)"]}
              unit=""
              onChange={(e) =>
                updateBendingCombinedObliqueInputs(
                  "moisture_class",
                  e.target.value
                )
              }
              value={bendingCombinedObliqueInputs["moisture_class"]}
            />
          </div>
          <div className={styles.inputElement}>
            <Select
              text="Tipo"
              elements={[
                "Madeira serrada",
                "Madeira roliça",
                "Madeira lamelada colada (MLC)",
                "Madeira lamelada colada cruzada (MLCC)",
                "Madeira laminada colada (LVL)",
                "Madeira recomposta",
              ]}
              unit=""
              onChange={(e) =>
                updateBendingCombinedObliqueInputs(
                  "timber_type",
                  e.target.value
                )
              }
              value={bendingCombinedObliqueInputs["timber_type"]}
            />
          </div>
          <div className={styles.inputElement}>
            <Select
              text="Classe de carregamento"
              elements={[
                "Permanente",
                "Longa duração",
                "Média duração",
                "Curta duração",
                "Instantânea",
              ]}
              unit=""
              onChange={(e) =>
                updateBendingCombinedObliqueInputs("load_class", e.target.value)
              }
              value={bendingCombinedObliqueInputs["load_class"]}
            />
          </div>
          <div className={styles.inputRow}>
            <InputNumber
              text="Lx"
              unit="cm"
              onChange={(e) =>
                updateBendingCombinedObliqueInputs("lx", e.target.value)
              }
            />
            <Select
              text="Kex"
              elements={[0.65, 0.8, 1.2, 1, 2.1, 2.4]}
              unit=""
              onChange={(e) =>
                updateBendingCombinedObliqueInputs("ke_x", e.target.value)
              }
              value={bendingCombinedObliqueInputs["ke_x"]}
            />
          </div>
          <div className={styles.inputRow}>
            <InputNumber
              text="Ly"
              unit="cm"
              onChange={(e) =>
                updateBendingCombinedObliqueInputs("ly", e.target.value)
              }
            />
            <Select
              text="Key"
              elements={[0.65, 0.8, 1.2, 1, 2.1, 2.4]}
              unit=""
              onChange={(e) =>
                updateBendingCombinedObliqueInputs("ke_y", e.target.value)
              }
              value={bendingCombinedObliqueInputs["ke_y"]}
            />
          </div>
          <div className={styles.inputRow}>
            <InputNumber
              text="b"
              unit="cm"
              onChange={(e) =>
                updateBendingCombinedObliqueInputs("b", e.target.value)
              }
            />
            <InputNumber
              text="h"
              unit="cm"
              onChange={(e) =>
                updateBendingCombinedObliqueInputs("h", e.target.value)
              }
            />
          </div>
          <div className={styles.inputRow}>
            <InputNumber
              text="af"
              unit="cm²"
              onChange={(e) =>
                updateBendingCombinedObliqueInputs("af", e.target.value)
              }
            />
          </div>
          <div className={styles.inputRow}>
            <Select
              text="Tipo de esforço"
              elements={["Tração", "Compressão"]}
              unit=""
              onChange={(e) =>
                updateBendingCombinedObliqueInputs(
                  "stress_type",
                  e.target.value
                )
              }
              value={bendingCombinedObliqueInputs["stress_type"]}
            />
            <InputNumber
              text="Nsd"
              unit="tf"
              onChange={(e) =>
                updateBendingCombinedObliqueInputs("nsd", e.target.value)
              }
            />
          </div>
          <div className={styles.inputRow}>
            <InputNumber
              text="Msd,x"
              unit="tf.m"
              onChange={(e) =>
                updateBendingCombinedObliqueInputs("msd_x", e.target.value)
              }
            />
            <InputNumber
              text="Msd,y"
              unit="tf.m"
              onChange={(e) =>
                updateBendingCombinedObliqueInputs("msd_y", e.target.value)
              }
            />
          </div>
        </div>
        <div className={styles.buttons}>
          <button
            className={styles.calculateButton}
            onClick={onBendingCombinedObliqueCalculate}
          >
            CALCULAR
          </button>
        </div>
        <div className={styles.outputs}>
          <div className={styles.outputRow}>
            <h3 className={styles.rowTitle}>Resumo de resultados:</h3>
          </div>
          <h4 className={styles.rowDescription}>Flexão</h4>
          <Output
            text="fm,d"
            value={bendingCombinedObliqueOutputs["fm_d"]}
            unit="MPa"
          />
          <h4>Momento em torno do eixo X</h4>
          <Output
            text="σMx,d"
            value={bendingCombinedObliqueOutputs["tens_mx_d"]}
            unit="MPa"
          />
          {bendingCombinedObliqueOutputs["tens_mx_d"] !== "" && (
            <h4 className={styles.rowDescription}>
              {bendingCombinedObliqueOutputs["tens_mx_d"].toFixed(2) +
                " ≤ " +
                bendingCombinedObliqueOutputs["fm_d"].toFixed(2) +
                " → "}
              {bendingCombinedObliqueOutputs["tens_mx_d"] <=
              bendingCombinedObliqueOutputs["fm_d"].toFixed(2)
                ? "OK!"
                : "NÃO OK!"}
            </h4>
          )}
          <h4>Momento em torno do eixo Y</h4>
          <Output
            text="σMy,d"
            value={bendingCombinedObliqueOutputs["tens_my_d"]}
            unit="MPa"
          />
          {bendingCombinedObliqueOutputs["tens_my_d"] !== "" && (
            <h4 className={styles.rowDescription}>
              {bendingCombinedObliqueOutputs["tens_my_d"].toFixed(2) +
                " ≤ " +
                bendingCombinedObliqueOutputs["fm_d"].toFixed(2) +
                " → "}
              {bendingCombinedObliqueOutputs["tens_my_d"] <=
              bendingCombinedObliqueOutputs["fm_d"].toFixed(2)
                ? "OK!"
                : "NÃO OK!"}
            </h4>
          )}
          <h4>Estabilidade lateral</h4>
          {bendingCombinedObliqueOutputs["tens_mx_d"] !== "" &&
            (bendingCombinedObliqueInputs["lx"] /
              bendingCombinedObliqueInputs["b"] <=
            bendingCombinedObliqueOutputs["limit_1"] ? (
              <h4 className={styles.rowDescription}>
                {(
                  bendingCombinedObliqueInputs["lx"] /
                  bendingCombinedObliqueInputs["b"]
                ).toFixed(2) +
                  " ≤ " +
                  bendingCombinedObliqueOutputs["limit_1"].toFixed(2) +
                  " → OK!"}
              </h4>
            ) : (
              <h4 className={styles.rowDescription}>
                {bendingCombinedObliqueOutputs["tens_mx_d"].toFixed(2) +
                  " ≤ " +
                  bendingCombinedObliqueOutputs["limit_2"].toFixed(2) +
                  " → "}
                {bendingCombinedObliqueOutputs["tens_mx_d"] <=
                bendingCombinedObliqueOutputs["limit_2"]
                  ? "OK!"
                  : "NÃO OK!"}
              </h4>
            ))}
          {bendingCombinedObliqueInputs["stress_type"] === "Tração" ? (
            <>
              <h4 className={styles.rowDescription}>Tração</h4>
              <Output
                text="ft0,d"
                value={bendingCombinedObliqueOutputs["ft0_d"]}
                unit="MPa"
              />

              {bendingCombinedObliqueOutputs["l0_x"] === "" ? (
                <h4 className={styles.rowDescription}>L0,x =</h4>
              ) : (
                <h4 className={styles.rowDescription}>
                  {"L0,x = " +
                    bendingCombinedObliqueOutputs["l0_x"].toFixed(2) +
                    " ≤ " +
                    (50 * bendingCombinedObliqueInputs["h"]).toFixed(2) +
                    " → "}
                  {bendingCombinedObliqueOutputs["l0_x"] <=
                  50 * bendingCombinedObliqueInputs["h"]
                    ? "OK!"
                    : "NÃO OK!"}
                </h4>
              )}
              {bendingCombinedObliqueOutputs["l0_y"] === "" ? (
                <h4 className={styles.rowDescription}>L0,y =</h4>
              ) : (
                <h4 className={styles.rowDescription}>
                  {"L0,y = " +
                    bendingCombinedObliqueOutputs["l0_y"].toFixed(2) +
                    " ≤ " +
                    (50 * bendingCombinedObliqueInputs["b"]).toFixed(2) +
                    " → "}
                  {bendingCombinedObliqueOutputs["l0_y"] <=
                  50 * bendingCombinedObliqueInputs["b"]
                    ? "OK!"
                    : "NÃO OK!"}
                </h4>
              )}
              <Output
                text="σNt,d"
                value={bendingCombinedObliqueOutputs["tens_nt_d"]}
                unit="MPa"
              />
              {bendingCombinedObliqueOutputs["tens_nt_d"] !== "" && (
                <h4 className={styles.rowDescription}>
                  {bendingCombinedObliqueOutputs["tens_nt_d"].toFixed(2) +
                    " ≤ " +
                    bendingCombinedObliqueOutputs["ft0_d"].toFixed(2) +
                    " → "}
                  {bendingCombinedObliqueOutputs["tens_nt_d"] <=
                  bendingCombinedObliqueOutputs["ft0_d"].toFixed(2)
                    ? "OK!"
                    : "NÃO OK!"}
                </h4>
              )}
            </>
          ) : (
            <>
              <h4 className={styles.rowDescription}>Compressão</h4>
              <Output
                text="fc0,d"
                value={bendingCombinedObliqueOutputs["fc0_d"]}
                unit="MPa"
              />
              {bendingCombinedObliqueOutputs["l0_x"] === "" ? (
                <h4 className={styles.rowDescription}>L0,x =</h4>
              ) : (
                <h4 className={styles.rowDescription}>
                  {"L0,x = " +
                    bendingCombinedObliqueOutputs["l0_x"].toFixed(2) +
                    " ≤ " +
                    (40 * bendingCombinedObliqueInputs["h"]).toFixed(2) +
                    " → "}
                  {bendingCombinedObliqueOutputs["l0_x"] <=
                  40 * bendingCombinedObliqueInputs["h"]
                    ? "OK!"
                    : "NÃO OK!"}
                </h4>
              )}
              {bendingCombinedObliqueOutputs["l0_y"] === "" ? (
                <h4 className={styles.rowDescription}>L0,y =</h4>
              ) : (
                <h4 className={styles.rowDescription}>
                  {"L0,y = " +
                    bendingCombinedObliqueOutputs["l0_y"].toFixed(2) +
                    " ≤ " +
                    (40 * bendingCombinedObliqueInputs["b"]).toFixed(2) +
                    " → "}
                  {bendingCombinedObliqueOutputs["l0_y"] <=
                  40 * bendingCombinedObliqueInputs["b"]
                    ? "OK!"
                    : "NÃO OK!"}
                </h4>
              )}
              {bendingCombinedObliqueOutputs["lambd_x"] === "" ? (
                <h4 className={styles.rowDescription}>λx =</h4>
              ) : (
                <h4 className={styles.rowDescription}>
                  {"λx = " +
                    bendingCombinedObliqueOutputs["lambd_x"].toFixed(2) +
                    " ≤ 140 → "}
                  {bendingCombinedObliqueOutputs["lambd_x"] <= 140
                    ? "OK!"
                    : "NÃO OK!"}
                </h4>
              )}
              {bendingCombinedObliqueOutputs["lambd_y"] === "" ? (
                <h4 className={styles.rowDescription}>λy =</h4>
              ) : (
                <h4 className={styles.rowDescription}>
                  {"λy = " +
                    bendingCombinedObliqueOutputs["lambd_y"].toFixed(2) +
                    " ≤ 140 → "}
                  {bendingCombinedObliqueOutputs["lambd_y"] <= 140
                    ? "OK!"
                    : "NÃO OK!"}
                </h4>
              )}
              <Output
                text="σNc,d"
                value={bendingCombinedObliqueOutputs["tens_nc_d"]}
                unit="MPa"
              />
              {bendingCombinedObliqueOutputs["tens_nc_d"] !== "" && (
                <h4 className={styles.rowDescription}>
                  {bendingCombinedObliqueOutputs["tens_nc_d"].toFixed(2) +
                    " ≤ " +
                    bendingCombinedObliqueOutputs["fc0_d"].toFixed(2) +
                    " → "}
                  {bendingCombinedObliqueOutputs["tens_nc_d"] <=
                  bendingCombinedObliqueOutputs["fc0_d"].toFixed(2)
                    ? "OK!"
                    : "NÃO OK!"}
                </h4>
              )}
              <h4>Estabilidade - Eixo X</h4>
              {bendingCombinedObliqueOutputs["lambd_rel_x"] === "" ? (
                <h4 className={styles.rowDescription}>λrel,x =</h4>
              ) : (
                <h4 className={styles.rowDescription}>
                  {"λrel,x = " +
                    bendingCombinedObliqueOutputs["lambd_rel_x"].toFixed(2) +
                    " ≤ 0.3 → "}
                  {bendingCombinedObliqueOutputs["lambd_rel_x"] <= 0.3
                    ? "OK!"
                    : "NÃO OK!"}
                </h4>
              )}
              {bendingCombinedObliqueOutputs["lambd_rel_x"] !== "" &&
                bendingCombinedObliqueOutputs["lambd_rel_x"] > 0.3 && (
                  <h4 className={styles.rowDescription}>
                    {bendingCombinedObliqueOutputs["verification_x"].toFixed(
                      2
                    ) + " ≤ 1 → "}
                    {bendingCombinedObliqueOutputs["verification_x"] <= 1
                      ? "OK!"
                      : "NÃO OK!"}
                  </h4>
                )}
              <h4>Estabilidade - Eixo Y</h4>
              {bendingCombinedObliqueOutputs["lambd_rel_y"] === "" ? (
                <h4 className={styles.rowDescription}>λrel,y =</h4>
              ) : (
                <h4 className={styles.rowDescription}>
                  {"λrel,y = " +
                    bendingCombinedObliqueOutputs["lambd_rel_y"].toFixed(2) +
                    " ≤ 0.3 → "}
                  {bendingCombinedObliqueOutputs["lambd_rel_y"] <= 0.3
                    ? "OK!"
                    : "NÃO OK!"}
                </h4>
              )}
              {bendingCombinedObliqueOutputs["lambd_rel_y"] !== "" &&
                bendingCombinedObliqueOutputs["lambd_rel_y"] > 0.3 && (
                  <h4 className={styles.rowDescription}>
                    {bendingCombinedObliqueOutputs["verification_y"].toFixed(
                      2
                    ) + " ≤ 1 → "}
                    {bendingCombinedObliqueOutputs["verification_y"] <= 1
                      ? "OK!"
                      : "NÃO OK!"}
                  </h4>
                )}
            </>
          )}
          <h4 className={styles.rowDescription}>Flexão Composta Oblíqua</h4>
          {bendingCombinedObliqueOutputs["verification"] !== "" && (
            <h4 className={styles.rowDescription}>
              {bendingCombinedObliqueOutputs["verification"].toFixed(2) +
                " ≤ 1 → "}
              {bendingCombinedObliqueOutputs["verification"] <= 1
                ? "OK!"
                : "NÃO OK!"}
            </h4>
          )}
        </div>
      </div>
      <div className={styles.memorial} key={"memorial"}>
        <h1>Memorial de Cálculo:</h1>
        {bendingCombinedObliqueOutputs["memorial"] &&
          Object.entries(bendingCombinedObliqueOutputs["memorial"]).map(
            ([className, subclasses]) => (
              <>
                <h2>{className}</h2>
                {Object.entries(subclasses).map(([subclassName, steps]) => (
                  <>
                    <h3>{subclassName}</h3>
                    {steps.map((step) => (
                      <>
                        <h4>{step["description"]}</h4>
                        <div className={styles.mathContainer}>
                          <BlockMath
                            math={step["formula"] + step["calculation"]}
                          />
                        </div>
                      </>
                    ))}
                  </>
                ))}
              </>
            )
          )}
      </div>
    </div>
  );
}

export default TimberBendingCombinedObliqueOblique;
